export default "__VITE_ASSET__cd280aba__"